import { useProductListFieldConfig } from '@ztechapps/product.common'

export const useListFieldConfig = () => {
  const fields = useProductListFieldConfig()

  //update the fields that should be shown only
  fields.remarks.isVisible = false
  fields.tags.isVisible = false
  fields.status.isVisible = false
  fields.quantityOnHand.isVisible = false
  fields.quantityOnHand.excludeOnDisplay = true
  fields.computedQuantity.isVisible = false
  fields.computedQuantity.excludeOnDisplay = true
  fields.verticalIn.isVisible = true
  fields.horizontalIn.isVisible = true
  fields.productType.isVisible = false
  fields.productType.excludeOnDisplay = true

  //set the size
  fields.name.size = 300
  fields.code.size = 200

  return fields
}
